import React from "react";
import { AiFillGithub, AiFillInstagram, AiOutlineWhatsApp } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const socialLinks = [
  { icon: <AiOutlineWhatsApp />, url: "https://wa.me/923424346670", name: "WhatsApp", color: "#25D366" },
  { icon: <AiFillGithub />, url: "https://github.com/Shahid-Sheimi", name: "GitHub", color: "#333" },
  { icon: <FaLinkedinIn />, url: "https://www.linkedin.com/in/shahid-ai-python/", name: "LinkedIn", color: "#0077b5" },
  { icon: <AiFillInstagram />, url: "https://www.instagram.com/shahid.hoossein/?hl=en", name: "Instagram", color: "#E1306C" },
];

const SocialPopup = () => {
  return (
    <div style={styles.container}>
      {socialLinks.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-item"
          style={{ backgroundColor: link.color }}
        >
          <span style={styles.icon}>{link.icon}</span>
          <span className="social-text" style={styles.text}>
            {link.name}
          </span>
        </a>
      ))}

      <style>{`
        .social-item {
          display: flex;
          align-items: center;
          border-radius: 25px 0 0 25px;   /* rounded left */
          height: 50px;
          width: 50px;                    /* collapsed */
          color: white;
          text-decoration: none;
          overflow: hidden;
          cursor: pointer;
          transition: width 0.3s ease, box-shadow 0.3s ease;
        }

        .social-text {
          opacity: 0;
          transform: translateX(20px);
          transition: opacity 0.3s ease, transform 0.3s ease;
          white-space: nowrap;
          font-size: 16px;
          margin-right: 12px;
        }

        .social-item:hover {
          width: 160px;                   /* expand only this */
          box-shadow: -2px 2px 12px rgba(0,0,0,0.3);
          justify-content: flex-start;
        }

        .social-item:hover .social-text {
  opacity: 1;
  transform: translateX(0);
  color: white;   /* 👈 this will make the text white */
}

        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    top: "30%",
    right: "0px",                // flush against right edge
    transform: "translateY(-50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",       // ✅ keeps siblings from shifting
    gap: "12px",
  },
  icon: {
    fontSize: "24px",
    margin: "0 12px",
  },
  text: {},
};

export default SocialPopup;
